import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import useTitle from '../../hooks/useTitle'

const Welcome = () => {

    const { firstname, isManager, isAdmin } = useAuth()

    useTitle('Welcome to DPE')

    const content = (
        <section id="main_content">
            <header>
                <h1 className="text-steel mt-5">
                    Welcome {firstname}
                </h1>
            </header>
            <main>
                <p className="mt-5">
                    Use the above menu to open up your <Link to="/dash/hep">Home Programs</Link>
                    {(isManager || isAdmin) && <span>, or review your <Link to="/dash/users">Therapists</Link></span>}
                </p>
                {(isManager || isAdmin) && <p>Click on the Exercises button to manage all <Link to="/dash/exercises">exercises</Link> in the system. You can mark exercises as your favorite, for quicker future selection of exercises.</p>}
                {(!isManager && !isAdmin) && <p>You can also review all the <Link to="/dash/exerciselist">exercises</Link> of this app, and mark some exercises as your favorites, which will can making a HEP quicker, and easier</p>}
                <p>
                    This App also has a built-in <Link to="/dash/todos">ToDo-list</Link>, so you can always keep up with all your tasks.
                </p>
                <p>
                    You can choose to use a dark, or a light theme. Cookies are used to store your preference for repeated use.
                </p>
            </main>
            <footer>
                <br/>
            </footer>
        </section>
    )

    return content
}
export default Welcome